<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <div class="animate__animated animate__slideInDown ">
      <div v-if="isSuccessful == false">
        <div class="login-header">
          <h1 class="login-title">To Retrieve your password</h1>
          <p class="login-subtitle">Enter your username to retrieve your password</p>
        </div>
        <form role="form" @submit.prevent="submitdetails">
          <div class="form-group">
            <label class="form-label" for="username">Username</label>
            <input type="text" id="username" class="form-input" v-model="username" placeholder="Enter your username"
              required>
          </div>
          <div>
            <button type="submit" class="login-button" :disabled="$store.state.appdatas.disenableifNotOnline">
              Submit <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </form>
        <div class="signup-link text-center">
          <router-link to="/login">Back to Login</router-link>
        </div>
      </div>
      <div class="" v-else>
        <div class="text-center my-3">
          <div class="login-header">
            <h1 class="login-title">Your password has been reset successfully</h1>
            <p class="login-subtitle">Enter your username to retrieve your password</p>
          </div>
        </div>
        <div class="text-center pt-2">
          <router-link to="/login" class="btn btn-outline-dark"><i class="fa fa-arrow-left"></i> Back to
            Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSpinner from "@/components/PageSpinner"
import RandomWord from "@/mixins/random-word-generator.mixin"
import Alert from "@/mixins/Alert.mixins"
export default {
  name: "Retrieve-password",
  mixins: [RandomWord, Alert],
  components: { PageSpinner },
  data() {
    return {
      username: "",
      errormsg: "",
      isSuccessful: false,
      onloader: "none",
    };
  },
  methods: {
    submitdetails: function () {
      let Username = `${this.RandomStringNumber(30)}${process.env.VUE_APP_ENV_USPAD}${btoa(this.username)}`;
      this.onloader = "flex";

      this.$store
        .dispatch("auth/RetrievePassword", Username)
        .then((resp) => {
          this.onloader = "none";
          if (resp.responseCode == '00') {
            this.isSuccessful = true
            this.ShowAlertSuccess(resp.responseMessage, '');
          } else {
            this.ShowAlertError(resp.responseMessage, '');
          }
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
  },
};
</script>

<style scoped>
.login-header {
  margin-bottom: 40px;
}

.login-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.login-subtitle {
  color: #777;
  font-size: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-input {
  width: 100%;
  padding: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input:focus {
  border-color: #6a11cb;
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.2);
  outline: none;
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
}

.forgot-password {
  color: #6a11cb;
  text-decoration: none;
  font-weight: 500;
}

.forgot-password:hover {
  text-decoration: underline;
}

.login-button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(106, 17, 203, 0.4);
}
</style>
